// @flow

import qs from 'qs';
import Api from './ApiBase';

export const getListParams = (params: any = {}) => qs.stringify({
  page: { limit: 10 }, ...params
});

class UsersApi extends Api {
  serializerType = 'users';

  serializerOptions = {
    attributes: ['fullName', 'email', 'phone', 'subscribedForNews'],
    typeForAttribute: (type: string) => {
      switch (type) {
      case 'fullName': return 'full_name';
      case 'subscribedForNews': return 'subscribed_for_news';
      default: return undefined;
      }
    }
  };

  fetchCurrentUser = async () => {
    const json = await this.request('user');
    const data = await this.deserialize(json);
    const { type } = json.data;

    return { ...data, type };
  }

  fetch = async (params: {} = {}) => {
    const json = await this.request(`users?${getListParams(params)}`);
    const data = await this.deserialize(json);

    return { data, meta: json.meta };
  }

  update = async (id: string | number, user: {}) => {
    const body = await this.serialize({ id, ...user });
    const json = await this.request(`users/${id}`, { body: JSON.stringify(body), method: 'PATCH' });
    const data = await this.deserialize(json);

    return { data };
  }

  destroy = async (id: number) => {
    await this.request(`users/${id}`, { method: 'DELETE' });
  }
}

export default new UsersApi();
